import React, { useState, useEffect } from 'react'
import { ProgressBar } from '../../components/ProgressBar/ProgressBar'
import { Footer } from '../../components/Footer/Footer'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import { ErrorMessage } from '../../components/ErrorMessage/ErrorMessage'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  useMediaQuery
} from '@mui/material'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { appTheme } from '../../theme'
import { container, inputFiledStyle } from '../../global'
import { useStyles } from './style'
import { useNavigate, useParams } from 'react-router-dom'
import Link from '@mui/material/Link'
import {
  updateFeature,
  eventDetail,
  updateFeature2
} from '../../services/EventService'
import { EventTitle } from '../../components/EventTitle/EventTitle'
import { PageTitle } from '../../components/PageTitle/PageTitle'
import FeaturesIcon from '../../images/featuresIcon.svg'
import { RadioButton } from '../../components/RadioButton/RadioButton'
import moment from 'moment'
import { EventType, Role } from '../../services/Types'

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

const PUBLIC_OR_PRIVATE = [
  'Public - All resources and materials to be posted to WorkforceGPS  (Common - most TA should be made public).',
  'Private - All recordings and materials to be made public after the live event concludes.',
  "Private -  all materials to remain private after the event (Uncommon, please explain in the 'Additional requests, Shutterstock ID#'s, notes, and/or instructions for your event' section below)."
]

const LOGISTIC_NEEDS = [
  'Audience Polling Questions.',
  'Screen share/website demo.',
  'Closed/private chat windows – only the moderators and speakers can see what the audience has typed.',
  'Other - please explain in the additional requests input below.'
]

const SUPPORT_NEEDED = [
  'Breakout rooms (Please indicate number below, up to 3)',
  'Allow attendees to unmute themselves for specific periods (interactive discussions or Q&A)',
  'Allow Attendees ability to turn on webcams',
  'American Sign Language Interpreter',
  'Other - please explain in the additional requests input below.'
]

var isWebView = true
const Item = styled(Paper)(({ theme }) =>
  isWebView
    ? { padding: theme.spacing(0, '96px', 3, '96px') }
    : { padding: theme.spacing(0, 4, 3, 4) }
)

export default function FeaturesAndRequestsPage() {
  let { id } = useParams()
  const classes = useStyles()
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))
  const [eventData, setEvent] = useState<any>({
    publicOrPrivate: PUBLIC_OR_PRIVATE[0],
    logisticNeed: [],
    supportNeeded: [],
    additionalRequest: '',
    featuresTranscription: 'No',
    featuresScript: 'No'
  })
  const [additionalRequestError, setAdditionalRequestError] = useState('')
  const [showServerError, setShowServerError] = useState(false)
  const [serverError, setServerError] = useState('')

  const navigate = useNavigate()
  const backClick = async () => {
    if (eventData.eventType === EventType.SERIES) navigate('/event/staff/' + id)
    else navigate('/event/dateAndTime/' + id)
  }

  useEffect(() => {
    showServerError &&
      setTimeout(() => {
        setShowServerError(false)
      }, 5000)
  }, [showServerError])

  const displayServerError = () => {
    setShowServerError(true)
    setServerError('Internal server error')
  }

  useEffect(() => {
    const loadEventData = async () => {
      try {
        const { data } = await eventDetail(Number(id))
        if (data) {
          if (data.eventDetail.statusCode === 200) {
            if (data.eventDetail.data === null) {
              return navigate('/')
            }
            if (data.eventDetail.data.creater.id !== user.id && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            if (data.eventDetail.data.status.startsWith('APPROVAL') && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            let liveRoomBooking = data.eventDetail.data.roomBooking?.find((x: any) => x.category === 'live')
            if (liveRoomBooking && Number(liveRoomBooking.date) < moment.utc().set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf() && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            setEvent({
              ...data.eventDetail.data,
              logisticNeed: JSON.parse(
                data.eventDetail.data.logisticNeed || '[]'
              ),
              supportNeeded: JSON.parse(
                data.eventDetail.data.supportNeeded || '[]'
              )
            })
          }
        }
      } catch (error) {
        displayServerError()
      }
    }

    loadEventData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const updateFeatureWebinar = async (nextClick?: boolean) => {
    try {
      const results = await updateFeature(
        eventData.id,
        eventData.programOfficeId,
        eventData.levelOneApproverId,
        eventData.otherApproverName,
        eventData.otherApproverEmail,
        eventData.publicOrPrivate,
        eventData.logisticNeed.length > 0
          ? JSON.stringify(eventData.logisticNeed)
          : '',
        eventData.supportNeeded.length > 0
          ? JSON.stringify(eventData.supportNeeded)
          : '',
        eventData.additionalRequest
      )
      const { data } = results
      if (data) {
        if (data.updateFeature.statusCode === 200) {
          if (nextClick) {
            if (eventData.eventType === EventType.SERIES) navigate('/event/dateAndTime/' + eventData.id)
            else navigate('/event/review/' + eventData.id)
          } else {
            navigate('/')
          }
        } else {
          displayServerError()
        }
      } else {
        displayServerError()
      }
    } catch (error) {
      displayServerError()
    }
  }

  const updateFeatureNotWebinar = async (nextClick?: boolean) => {
    try {
      const results = await updateFeature2(
        eventData.id,
        eventData.publicOrPrivate,
        eventData.featuresTranscription,
        eventData.featuresScript,
        eventData.additionalRequest
      )
      const { data } = results
      if (data) {
        if (data.updateFeature2.statusCode === 200) {
          if (nextClick) {
            if (eventData.eventType === EventType.SERIES) navigate('/event/dateAndTime/' + eventData.id)
            else navigate('/event/review/' + eventData.id)
          } else {
            navigate('/')
          }
        } else {
          displayServerError()
        }
      } else {
        displayServerError()
      }
    } catch (error) {
      displayServerError()
    }
  }

  const nextClick = async () => {
    if (eventData.eventType === 'Webinar') {
      if (!validateFeaturesAndRequests()) {
        return
      }
      updateFeatureWebinar(true)
    } else {
      if (!validateFeaturesAndRequestsNotWebinar()) {
        return
      }
      updateFeatureNotWebinar(true)
    }
  }

  const saveExit = async () => {
    if (eventData.eventType === 'Webinar') {
      if (!validateFeaturesAndRequests()) {
        return
      }
      updateFeatureWebinar()
    } else {
      if (!validateFeaturesAndRequestsNotWebinar()) {
        return
      }
      updateFeatureNotWebinar()
    }
  }

  const [publicPrivateErrorMessage, setPublicPrivateErrorMessage] = useState('')
  const [virtualFeaturesErrorMessage, setVirtualFeaturesErrorMessage] =
    useState('')

  const publicOrPrivateValidator = (publicOrPrivate: string) => {
    if (!publicOrPrivate || publicOrPrivate === '') {
      return 'Please select an event type option.'
    }
    return ''
  }

  const validateFeaturesAndRequests = () => {
    let validate = true
    if (publicOrPrivateValidator(eventData.publicOrPrivate) !== '') {
      setPublicPrivateErrorMessage(
        publicOrPrivateValidator(eventData.publicOrPrivate)
      )
      if (validate)
        document
          .getElementById('public-private-error')
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      validate = false
    }
    return validate
  }

  const validateFeaturesAndRequestsNotWebinar = () => {
    let validate = true
    if (publicOrPrivateValidator(eventData.publicOrPrivate) !== '') {
      setPublicPrivateErrorMessage(
        publicOrPrivateValidator(eventData.publicOrPrivate)
      )
      if (validate)
        document
          .getElementById('public-private-error')
          ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      validate = false
    }

    return validate
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name
    setEvent({ ...eventData, [name]: event.target.value })

    name === 'publicOrPrivate' &&
      setPublicPrivateErrorMessage(publicOrPrivateValidator(event.target.value))

    name === 'additionalRequest' &&
      setAdditionalRequestError(
        event.target.value.length >= 500 ? 'Character limit reached' : ''
      )
  }

  const handleCheck =
    (type: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      let data
      if (event.target.checked) data = [...eventData[type], event.target.name]
      else data = eventData[type].filter((x: any) => x !== event.target.name)

      setEvent({ ...eventData, [type]: data })

      type === 'logisticNeed' && setVirtualFeaturesErrorMessage('')
    }

  return (
    <Box className={classes.root}>
      <ProgressBar
        activePageTitle='Features & Requests'
        requestType={eventData.eventType}
      />

      <Item sx={{ bgcolor: 'rgba(0, 0, 0, 0.02)' }}>
        <Box style={container}>
          <Grid container>
            {showServerError && (
              <Grid item xs={12} sm={12} md={12}>
                <ErrorMessage
                  message={serverError}
                  justifyContent='center'
                  icon={true}
                />
              </Grid>
            )}

            <EventTitle title={eventData.title} />

            <Box
              sx={{
                width: { lg: '1248px' },
                borderRadius: '40px',
                px: { lg: '32px', md: '32px', sm: '21px', xs: '21px' },
                py: { lg: '24px', md: '24px', sm: '21px', xs: '21px' },
                mb: 8,
                gap: { lg: '24px', md: '24px', xs: '21px' },
                backgroundColor: '#FFFFFF'
              }}
            >
              <Box sx={{ mb: '20px'}}>
                <PageTitle
                  title='Features & Requests'
                  iconPath={FeaturesIcon}
                />
              </Box>
              <Alert severity='warning'>
                <AlertTitle>Changing Features & Requests</AlertTitle>
                <Typography variant="body2">
                  Once your event is approved, revisions to features and/or requests cannot be guaranteed. Event Support will follow-up to confirm what can be accommodated once you re-submit.
                </Typography>
              </Alert>

              <Grid
                lg={12}
                md={12}
                overflow='auto'
                className={classes.scrollableControl}
                item
              >
                {/* Private / Public */}
                <>
                  <Typography
                    align='left'
                    variant='subtitle1'
                    sx={{ mb: 1, fontWeight: '500', color: '#333333' }}
                  >
                    Is this event public or private?
                    <Box
                      id='public-private-error'
                      sx={{ color: 'error.main', display: 'inline' }}
                    >
                      {' '}
                      *
                    </Box>
                  </Typography>
                  {publicPrivateErrorMessage && (
                    <Typography
                      align='left'
                      variant='body1'
                      sx={{
                        mb: 1,
                        mt: -1,
                        fontWeight: '400',
                        color: 'error.main'
                      }}
                    >
                      {publicPrivateErrorMessage}
                    </Typography>
                  )}

                  <RadioButton
                    name='publicOrPrivate'
                    selected={eventData.publicOrPrivate}
                    handleChange={handleChange}
                    radioButtons={PUBLIC_OR_PRIVATE.map(x => {
                      return {
                        value: x,
                        label: x
                      }
                    })}
                  />
                </>

                {/* Virtual Features */}
                {eventData.eventType === 'Webinar' && (
                  <>
                    <Typography
                      align='left'
                      variant='subtitle1'
                      sx={{ mt: 3, mb: 2, fontWeight: '500', color: '#333333' }}
                    >
                      Select all the virtual features you would like to
                      incorporate into your event to help us better understand
                      your logistic needs.
                    </Typography>
                    {virtualFeaturesErrorMessage && (
                      <Typography
                        align='left'
                        variant='body1'
                        sx={{
                          mb: 1,
                          mt: -1,
                          fontWeight: '400',
                          color: 'error.main'
                        }}
                      >
                        {virtualFeaturesErrorMessage}
                      </Typography>
                    )}
                    <Box className={classes.radioGroupBox}>
                      <FormGroup>
                        {LOGISTIC_NEEDS.map(x => (
                          <FormControlLabel
                            key={x}
                            sx={{
                              ml: { sm: 2.5, xs: 0 },
                              mt: '13px',
                              gap: '12px'
                            }}
                            style={{
                              display: 'flex',
                              alignItems: 'center'
                            }}
                            control={
                              <Checkbox
                                name={x}
                                checked={eventData.logisticNeed.includes(x)}
                                size='small'
                                onChange={handleCheck('logisticNeed')}
                                style={{
                                  padding: '0 12px',
                                  width: '20px',
                                  height: '20px',
                                  color: '#565656'
                                }}
                              />
                            }
                            label={
                              <Typography sx={{ textAlign: 'left' }}>
                                {x}
                              </Typography>
                            }
                          />
                        ))}
                      </FormGroup>
                    </Box>
                  </>
                )}

                {/* Transcription */}
                {eventData.eventType !== EventType.WEBINAR && eventData.eventType !== EventType.SERIES && (
                  <>
                    <Typography
                      align='left'
                      variant='subtitle1'
                      sx={{
                        mt: '28px',
                        mb: '24px',
                        fontWeight: '500',
                        color: '#333333'
                      }}
                    >
                      Will you require transcription?
                    </Typography>

                    <RadioButton
                      name='featuresTranscription'
                      selected={eventData.featuresTranscription}
                      handleChange={handleChange}
                      radioButtons={[
                        {
                          value: 'Yes',
                          label: 'Yes'
                        },
                        {
                          value: 'No',
                          label: 'No, I will be providing a script'
                        }
                      ]}
                    />
                  </>
                )}

                {/* Specical Requests */}
                {eventData.eventType === 'Webinar' && (
                  <>
                    <Typography
                      align='left'
                      variant='subtitle1'
                      sx={{
                        mt: '28px',
                        mb: '24px',
                        fontWeight: '500',
                        color: '#333333'
                      }}
                    >
                      Special Requests - May require approval from TAU due to
                      additional support needed.
                    </Typography>
                    <Box className={classes.radioGroupBox}>
                      <FormGroup>
                        {SUPPORT_NEEDED.map((x, index) => {
                          if (eventData.overHundredParticipants && index < 3)
                            return <></>
                          else
                            return (
                              <FormControlLabel
                                key={x}
                                sx={{
                                  ml: { sm: 2.5, xs: 0 },
                                  mt: '13px',
                                  gap: '12px',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                                control={
                                  <Checkbox
                                    name={x}
                                    checked={eventData.supportNeeded.includes(
                                      x
                                    )}
                                    size='small'
                                    onChange={handleCheck('supportNeeded')}
                                    style={{
                                      padding: '0 12px',
                                      width: '20px',
                                      height: '20px',
                                      color: '#565656'
                                    }}
                                  />
                                }
                                label={
                                  <Typography sx={{ textAlign: 'left' }}>
                                    {x}
                                  </Typography>
                                }
                              />
                            )
                        })}
                      </FormGroup>
                    </Box>
                  </>
                )}

                {/* Additional Request */}
                <Grid lg={10} md={10} sm={12} item>
                  <Typography
                    align='left'
                    variant='subtitle1'
                    color='#333333'
                    sx={{ mt: '28px', mb: '24px', fontWeight: '500' }}
                  >
                    Additional Features & Requests
                  </Typography>

                  <Box
                    sx={{
                      mt: -1,
                      ml: { sm: 0, xs: 0 },
                      mr: { sm: 1.25, xs: 0 }
                    }}
                  >
                    <TextField
                      style={inputFiledStyle}
                      sx={{
                        mb: 5,
                        bgcolor: 'white',
                        ...(!!additionalRequestError && {
                          '.MuiOutlinedInput-root.Mui-focused': {
                            fieldset: { borderColor: '#D50000' }
                          }
                        }),
                        '.MuiOutlinedInput-root.Mui-focused': {
                          fieldset: { borderColor: '#006BD7' }
                        },
                        [`& fieldset`]: {
                          borderRadius: '8px'
                        }
                      }}
                      name='additionalRequest'
                      value={eventData.additionalRequest || ''}
                      onChange={handleChange}
                      multiline
                      rows={3}
                      placeholder='Use this field to request features or share instructions or notes not already captured, such as Shutterstock URLs for graphics or other event specific needs. Event Support will follow-up to confirm what requests can be accommodated.'
                      fullWidth
                      inputProps={{ maxLength: 500 }}
                      InputLabelProps={{ shrink: true }}
                      error={!!additionalRequestError}
                    />
                    <Box sx={{ display: 'flex' }}>
                      <Typography
                        sx={{
                          color: '#D50000',
                          flex: 1,
                          fontSize: 12,
                          ml: 3,
                          textAlign: 'left'
                        }}
                      >
                        {additionalRequestError}
                      </Typography>
                      <Typography
                        sx={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 12 }}
                      >
                        {eventData.additionalRequest?.length || 0} / 500
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Box>
        <Footer
          saveExit={saveExit}
          nextClick={nextClick}
          backClick={backClick}
          activePageTitle='Features & Requests'
        />
      </Item>
    </Box>
  )
}
